<template>
    <div class="credit_page">
        <div class="container">
            <section class="breadcrumb-section design_studio_bread_crumb_sec">
                <div class="container">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <router-link to="/">Home</router-link>
                            </li>
                            <li
                                class="breadcrumb-item active"
                                aria-current="page"
                            >
                                Business Credit Application
                            </li>
                        </ol>
                    </nav>
                </div>
            </section>
            <section class="credit_section pt_10">
                <div class="container">
                    <div class="stepwizard col-md-offset-3">
                        <div class="stepwizard-row setup-panel">
                            <div class="stepwizard-step">
                                <a
                                    href="#step-1"
                                    type="button"
                                    class="btn btn-primary btn-circle"
                                    ><span>1</span>
                                    <img
                                        class="submit_check"
                                        src="/maincss/images/blue-check1.svg"
                                        alt=""
                                /></a>
                                <p>Name / Address</p>
                            </div>
                            <div class="stepwizard-step step_2">
                                <a
                                    href="#step-2"
                                    type="button"
                                    class="btn btn-default btn-circle"
                                    disabled="disabled"
                                    ><span>2</span>
                                    <img
                                        class="submit_check"
                                        src="/maincss/images/blue-check1.svg"
                                        alt=""
                                /></a>

                                <p>Company Information</p>
                            </div>
                            <div class="stepwizard-step">
                                <a
                                    href="#step-3"
                                    type="button"
                                    class="btn btn-default btn-circle"
                                    disabled="disabled"
                                    ><span>3</span>
                                    <img
                                        class="submit_check"
                                        src="/maincss/images/blue-check1.svg"
                                        alt=""
                                /></a>

                                <p>Bank Referance</p>
                            </div>
                            <div class="stepwizard-step">
                                <a
                                    href="#step-4"
                                    type="button"
                                    class="btn btn-default btn-circle"
                                    disabled="disabled"
                                    ><span>4</span>
                                    <img
                                        class="submit_check"
                                        src="/maincss/images/blue-check1.svg"
                                        alt=""
                                /></a>
                                <p>Trade Referance</p>
                            </div>
                            <div class="stepwizard-step">
                                <a
                                    href="#step-5"
                                    type="button"
                                    class="btn btn-default btn-circle"
                                    disabled="disabled"
                                    >5</a
                                >

                                <p>Signature & Date</p>
                            </div>
                        </div>
                    </div>

                    <form role="form" action="" method="post">
                        <div class="row setup-content" id="step-1">
                            <div class="card_body">
                                <div class="col-xs-6 col-md-offset-3">
                                    <div class="col-md-12">
                                        <h3>Name / Address</h3>
                                        <div class="form_main">
                                            <div class="form-group col-md-4">
                                                <label class="control-label"
                                                    >Last</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="text"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="Toussaint"
                                                />
                                            </div>
                                            <div class="form-group col-md-4">
                                                <label class="control-label"
                                                    >First</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="text"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="Wilma"
                                                />
                                            </div>
                                            <div class="form-group col-md-4">
                                                <label class="control-label"
                                                    >Middle Initial</label
                                                >
                                                <input
                                                    required="required"
                                                    type="text"
                                                    class="form-control"
                                                    placeholder="John"
                                                />
                                            </div>
                                            <div class="form-group col-md-12">
                                                <label class="control-label"
                                                    >Title</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="text"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="Robust Secondary Firmware"
                                                />
                                            </div>
                                            <div class="form-group col-md-6">
                                                <label class="control-label"
                                                    >Name of Business</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="text"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="Kub LLC"
                                                />
                                            </div>
                                            <div class="form-group col-md-6">
                                                <label class="control-label"
                                                    >Tax I.D Number</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="number"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="85-6715344"
                                                />
                                            </div>
                                            <div class="form-group col-md-12">
                                                <label class="control-label"
                                                    >Address</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="text"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="3734 Green Gate Lanes"
                                                />
                                            </div>
                                            <div class="form-group col-md-3">
                                                <label class="control-label"
                                                    >City</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="text"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="Baltimore"
                                                />
                                                <img
                                                    src="/maincss/images/Polygon.svg"
                                                    alt=""
                                                />
                                            </div>
                                            <div class="form-group col-md-3">
                                                <label class="control-label"
                                                    >State</label
                                                >
                                                <!-- <input maxlength="100" type="text" required="required" class="form-control"
                          placeholder="Maryland"> -->
                                                <select
                                                    class="form-select form-control"
                                                    aria-label="Default select example"
                                                >
                                                    <option selected>
                                                        Open this select menu
                                                    </option>
                                                    <option value="1">
                                                        MP
                                                    </option>
                                                    <option value="2">
                                                        MH
                                                    </option>
                                                    <option value="3">
                                                        UP
                                                    </option>
                                                </select>
                                                <img
                                                    src="/maincss/images/Polygon.svg"
                                                    alt=""
                                                />
                                            </div>
                                            <div class="form-group col-md-3">
                                                <label class="control-label"
                                                    >Zip</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="number"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="21202"
                                                />
                                            </div>
                                            <div class="form-group col-md-3">
                                                <label class="control-label"
                                                    >Phone</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="number"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="443-752-3050"
                                                />
                                            </div>
                                        </div>
                                        <div class="credit_footer">
                                            <button
                                                class="btn btn-primary prevBtn btn-lg pull-left btn_pre mr_20"
                                                type="button"
                                            >
                                                previous
                                            </button>
                                            <button
                                                class="btn btn_orange bg_primary_orange text_white des_add_cart nextBtn btn-lg pull-right btn_next"
                                                type="button"
                                            >
                                                Next
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row setup-content" id="step-2">
                            <div class="card_body">
                                <div class="col-xs-6 col-md-offset-3">
                                    <div class="col-md-12">
                                        <h3>Company Information</h3>
                                        <div class="form_main">
                                            <div class="form-group col-md-6">
                                                <label class="control-label"
                                                    >Type of bussiness</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="text"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="Kub LLC"
                                                />
                                            </div>
                                            <div class="form-group col-md-6">
                                                <label class="control-label"
                                                    >In Bussiness Since</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="text"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="2010"
                                                />
                                            </div>
                                            <p class="choose_title">
                                                Legal Form Under Which Business
                                                Operates
                                            </p>
                                            <div
                                                class="form-group col-md-4 choose_field"
                                            >
                                                <input
                                                    required="required"
                                                    type="radio"
                                                    class="radio-field"
                                                    placeholder="Enter your address"
                                                />
                                                <label class=""
                                                    >Corporation</label
                                                >
                                            </div>
                                            <div
                                                class="form-group col-md-4 choose_field"
                                            >
                                                <input
                                                    required="required"
                                                    type="radio"
                                                    class="radio-field"
                                                    placeholder="Enter your address"
                                                />
                                                <label class=""
                                                    >Partnership</label
                                                >
                                            </div>
                                            <div
                                                class="form-group col-md-4 choose_field"
                                            >
                                                <input
                                                    required="required"
                                                    type="radio"
                                                    class="radio-field"
                                                    placeholder="Enter your address"
                                                />
                                                <label class=""
                                                    >Proprietorship</label
                                                >
                                            </div>
                                            <div class="form-group col-md-6">
                                                <label class="control-label"
                                                    >If Division/Subsidiary,
                                                    Name of Parent
                                                    Company</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="text"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="Ritchie Ltd"
                                                />
                                            </div>
                                            <div class="form-group col-md-6">
                                                <label class="control-label"
                                                    >In Business Since</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="number"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="2018"
                                                />
                                            </div>
                                            <div class="form-group col-md-6">
                                                <label class="control-label"
                                                    >Name of Company Principal
                                                    Responsible for Business
                                                    Transaction</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="text"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="Ruecker-Dach"
                                                />
                                            </div>
                                            <div class="form-group col-md-6">
                                                <label class="control-label"
                                                    >Title</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="text"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="Public-Key Multi-Tasking Definition"
                                                />
                                            </div>
                                            <div class="form-group col-md-6">
                                                <label class="control-label"
                                                    >Email Address</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="text"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="michal.joe@gmail.com"
                                                />
                                            </div>
                                            <div class="form-group col-md-6">
                                                <label class="control-label"
                                                    >Physical Address</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="text"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="4985 Tanglewood Road"
                                                />
                                            </div>
                                            <div class="form-group col-md-3">
                                                <label class="control-label"
                                                    >City</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="text"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="Olive Branch"
                                                />
                                                <img
                                                    src="/maincss/images/Polygon.svg"
                                                    alt=""
                                                />
                                            </div>
                                            <div class="form-group col-md-3">
                                                <label class="control-label"
                                                    >State</label
                                                >

                                                <select
                                                    class="form-select form-control"
                                                    aria-label="Default select example"
                                                >
                                                    <option selected>
                                                        Open this select menu
                                                    </option>
                                                    <option value="1">
                                                        MP
                                                    </option>
                                                    <option value="2">
                                                        MH
                                                    </option>
                                                    <option value="3">
                                                        UP
                                                    </option>
                                                </select>
                                                <img
                                                    src="/maincss/images/Polygon.svg"
                                                    alt=""
                                                />
                                            </div>
                                            <div class="form-group col-md-3">
                                                <label class="control-label"
                                                    >ZIP</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="number"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="38654"
                                                />
                                            </div>
                                            <div class="form-group col-md-3">
                                                <label class="control-label"
                                                    >Phone</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="number"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="662-892-7083"
                                                />
                                            </div>
                                            <div
                                                class="form-group col-md-12 last_sign_field above"
                                            >
                                                <input
                                                    maxlength="100"
                                                    type="checkbox"
                                                    required="required"
                                                    class=""
                                                    placeholder="Acme Bank Credit Card Service"
                                                />
                                                <p class="signature_content">
                                                    Same as above
                                                </p>
                                            </div>
                                            <div class="form-group col-md-12">
                                                <label class="control-label"
                                                    >Billing Address</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="text"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="3734 Green Gate Lane"
                                                />
                                            </div>
                                            <div class="form-group col-md-3">
                                                <label class="control-label"
                                                    >City</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="text"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="Baltimore"
                                                />
                                                <img
                                                    src="/maincss/images/Polygon.svg"
                                                    alt=""
                                                />
                                            </div>
                                            <div class="form-group col-md-3">
                                                <label class="control-label"
                                                    >State</label
                                                >
                                                <select
                                                    class="form-select form-control"
                                                    aria-label="Default select example"
                                                >
                                                    <option selected>
                                                        Open this select menu
                                                    </option>
                                                    <option value="1">
                                                        MP
                                                    </option>
                                                    <option value="2">
                                                        MH
                                                    </option>
                                                    <option value="3">
                                                        UP
                                                    </option>
                                                </select>
                                                <img
                                                    src="/maincss/images/Polygon.svg"
                                                    alt=""
                                                />
                                            </div>
                                            <div class="form-group col-md-3">
                                                <label class="control-label"
                                                    >ZIP</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="number"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="21202"
                                                />
                                            </div>
                                            <div class="form-group col-md-3">
                                                <label class="control-label"
                                                    >Phone</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="number"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="443-752-3050"
                                                />
                                            </div>
                                            <h5 class="center_title">
                                                Accounts Payable Contact Name
                                            </h5>
                                            <div class="form-group col-md-6">
                                                <label class="control-label"
                                                    >Phone</label
                                                >
                                                <div class="two_col_input">
                                                    <select
                                                        class="form-select form-control dropdown"
                                                        aria-label="Default select example"
                                                    >
                                                        <option selected>
                                                            +1
                                                        </option>
                                                        <option value="1">
                                                            +91
                                                        </option>
                                                        <option value="2">
                                                            +92
                                                        </option>
                                                        <option value="3">
                                                            +93
                                                        </option>
                                                    </select>

                                                    <img
                                                        class="drop_icon"
                                                        src="/maincss/images/Polygon.svg"
                                                        alt=""
                                                    />
                                                    <input
                                                        maxlength="80"
                                                        type="text"
                                                        required="required"
                                                        class="form-control phone_input"
                                                        placeholder="866-303-7827"
                                                    />
                                                </div>
                                            </div>
                                            <div class="form-group col-md-6">
                                                <label class="control-label"
                                                    >Email Address</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="text"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="michal.joe@gmail.com"
                                                />
                                            </div>
                                        </div>
                                        <div class="credit_footer">
                                            <button
                                                class="btn btn-primary prevBtn btn-lg pull-left btn_pre mr_20"
                                                type="button"
                                            >
                                                previous
                                            </button>
                                            <button
                                                class="btn btn_orange bg_primary_orange text_white des_add_cart nextBtn btn-lg pull-right btn_next"
                                                type="button"
                                            >
                                                Next
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row setup-content" id="step-3">
                            <div class="card_body">
                                <div class="col-xs-6 col-md-offset-3">
                                    <div class="col-md-12">
                                        <h3>Bank References</h3>
                                        <div class="form_main">
                                            <div class="form-group col-md-12">
                                                <label class="control-label"
                                                    >Institution Name</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="text"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="Acme Bank Credit Card Service"
                                                />
                                            </div>
                                            <div class="form-group col-md-12">
                                                <label class="control-label"
                                                    >Checking Account #</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="text"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="654895"
                                                />
                                            </div>
                                            <div class="form-group col-md-12">
                                                <label class="control-label"
                                                    >Address</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="text"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="3734 Green Gate Lane"
                                                />
                                            </div>
                                            <div class="form-group col-md-12">
                                                <label class="control-label"
                                                    >Phone</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="text"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="443-752-3050"
                                                />
                                            </div>
                                        </div>
                                        <div class="credit_footer">
                                            <button
                                                class="btn btn-primary prevBtn btn-lg pull-left btn_pre mr_20"
                                                type="button"
                                            >
                                                previous
                                            </button>
                                            <button
                                                class="btn btn_orange bg_primary_orange text_white des_add_cart nextBtn btn-lg pull-right btn_next"
                                                type="button"
                                            >
                                                Next
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row setup-content" id="step-4">
                            <div class="card_body">
                                <div class="col-xs-6 col-md-offset-3">
                                    <div class="col-md-12">
                                        <h3>Bank References</h3>
                                        <div class="form_main">
                                            <div class="form-group col-md-4">
                                                <h6 class="company-title">
                                                    Company 1
                                                </h6>
                                            </div>
                                            <div class="form-group col-md-4">
                                                <h6 class="company-title">
                                                    Company 2
                                                </h6>
                                            </div>
                                            <div class="form-group col-md-4">
                                                <h6 class="company-title">
                                                    Company 3
                                                </h6>
                                            </div>

                                            <div class="form-group col-md-4">
                                                <label class="control-label"
                                                    >Company Name</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="text"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="Kub LLC"
                                                />
                                            </div>
                                            <div class="form-group col-md-4">
                                                <label class="control-label"
                                                    >Company Name</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="text"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="Ritchie Ltd"
                                                />
                                            </div>
                                            <div class="form-group col-md-4">
                                                <label class="control-label"
                                                    >Company Name</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="text"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="Ruecker-Dach"
                                                />
                                            </div>
                                            <div class="form-group col-md-4">
                                                <label class="control-label"
                                                    >Contact Name</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="text"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="Jeffery C. Perkins"
                                                />
                                            </div>
                                            <div class="form-group col-md-4">
                                                <label class="control-label"
                                                    >Contact Name</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="text"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="654895"
                                                />
                                            </div>
                                            <div class="form-group col-md-4">
                                                <label class="control-label"
                                                    >Contact Name</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="text"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="Gary Z. Montano"
                                                />
                                            </div>
                                            <div class="form-group col-md-4">
                                                <label class="control-label"
                                                    >Address</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="text"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="3734 Green Gate Lane"
                                                />
                                            </div>
                                            <div class="form-group col-md-4">
                                                <label class="control-label"
                                                    >Address</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="text"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="2832 Fire Access Road"
                                                />
                                            </div>
                                            <div class="form-group col-md-4">
                                                <label class="control-label"
                                                    >Address</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="text"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="386 Bastin Drive"
                                                />
                                            </div>
                                            <div class="form-group col-md-4">
                                                <label class="control-label"
                                                    >Phone</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="number"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="443-752-3050"
                                                />
                                            </div>
                                            <div class="form-group col-md-4">
                                                <label class="control-label"
                                                    >Phone</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="number"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="336-856-2743"
                                                />
                                            </div>
                                            <div class="form-group col-md-4">
                                                <label class="control-label"
                                                    >Phone</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="number"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="484-685-1271"
                                                />
                                            </div>
                                            <div class="form-group col-md-4">
                                                <label class="control-label"
                                                    >Account Opened Since</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="number"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="2010"
                                                />
                                            </div>
                                            <div class="form-group col-md-4">
                                                <label class="control-label"
                                                    >Account Opened Since</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="number"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="2018"
                                                />
                                            </div>
                                            <div class="form-group col-md-4">
                                                <label class="control-label"
                                                    >Account Opened Since</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="number"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="2020"
                                                />
                                            </div>
                                            <div class="form-group col-md-2">
                                                <label class="control-label"
                                                    >Credit Limit</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="number"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="$10000"
                                                />
                                            </div>
                                            <div class="form-group col-md-2">
                                                <label class="control-label"
                                                    >Credit Limit</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="number"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="$10000"
                                                />
                                            </div>
                                            <div class="form-group col-md-2">
                                                <label class="control-label"
                                                    >Credit Limit</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="number"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="$5000"
                                                />
                                            </div>
                                            <div class="form-group col-md-2">
                                                <label class="control-label"
                                                    >Credit Limit</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="number"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="$4000"
                                                />
                                            </div>
                                            <div class="form-group col-md-2">
                                                <label class="control-label"
                                                    >Credit Limit</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="number"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="$2000"
                                                />
                                            </div>
                                            <div class="form-group col-md-2">
                                                <label class="control-label"
                                                    >Credit Limit</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="number"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="$1000"
                                                />
                                            </div>
                                            <div
                                                class="form-group col-md-4 progress_field"
                                            >
                                                <div class="progress">
                                                    <div
                                                        style="width: 20%"
                                                        class="progress-bar"
                                                        role="progressbar"
                                                        aria-valuenow="0"
                                                        aria-valuemin="0"
                                                        aria-valuemax="100"
                                                    ></div>
                                                </div>
                                                <span>$1000</span>
                                            </div>
                                            <div
                                                class="form-group col-md-4 progress_field"
                                            >
                                                <div class="progress">
                                                    <div
                                                        style="width: 40%"
                                                        class="progress-bar"
                                                        role="progressbar"
                                                        aria-valuenow="0"
                                                        aria-valuemin="0"
                                                        aria-valuemax="100"
                                                    ></div>
                                                </div>
                                                <span>$1000</span>
                                            </div>
                                            <div
                                                class="form-group col-md-4 progress_field"
                                            >
                                                <div class="progress">
                                                    <div
                                                        style="width: 60%"
                                                        class="progress-bar"
                                                        role="progressbar"
                                                        aria-valuenow="0"
                                                        aria-valuemin="0"
                                                        aria-valuemax="100"
                                                    ></div>
                                                </div>
                                                <span>$1000</span>
                                            </div>
                                        </div>
                                        <div class="credit_footer">
                                            <button
                                                class="btn btn-primary prevBtn btn-lg pull-left btn_pre mr_20"
                                                type="button"
                                            >
                                                previous
                                            </button>
                                            <button
                                                class="btn btn_orange bg_primary_orange text_white des_add_cart nextBtn btn-lg pull-right btn_next"
                                                type="button"
                                            >
                                                Next
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row setup-content" id="step-5">
                            <div class="card_body">
                                <div class="col-xs-6 col-md-offset-3">
                                    <div class="col-md-12">
                                        <h3>Signature & Date</h3>
                                        <div class="form_main">
                                            <div
                                                class="form-group col-md-12 last_sign_field"
                                            >
                                                <input
                                                    maxlength="100"
                                                    type="checkbox"
                                                    required="required"
                                                    class=""
                                                    placeholder="Acme Bank Credit Card Service"
                                                />
                                                <p class="signature_content">
                                                    I hereby certify that I am
                                                    authorized to apply for
                                                    credit for the company. I
                                                    also certify that the
                                                    information contained herein
                                                    is complete and accurate.
                                                    This information has been
                                                    furnished with the
                                                    understanding that it is to
                                                    be used to determine the
                                                    amount and conditions of the
                                                    credit to be extended.
                                                    Furthermore, I hereby
                                                    authorize the financial
                                                    institutions listed in this
                                                    credit application to
                                                    release necessary
                                                    information to the company
                                                    for which credit is being
                                                    applied for in order to
                                                    verify the information
                                                    contained herein.
                                                </p>
                                            </div>
                                            <div
                                                id="canvas-sign"
                                                class="form-group col-md-12 signature_block"
                                            >
                                                <label class="control-label"
                                                    >Signature</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="signature"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder=""
                                                />
                                            </div>
                                            <div class="form-group col-md-2">
                                                <label class="control-label"
                                                    >Signee Name</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="text"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="Micheal Joe"
                                                />
                                            </div>
                                            <div class="form-group col-md-2">
                                                <label class="control-label"
                                                    >Date</label
                                                >
                                                <input
                                                    maxlength="100"
                                                    type="date"
                                                    required="required"
                                                    class="form-control"
                                                    placeholder="03/14/2023"
                                                />
                                            </div>
                                        </div>
                                        <div class="credit_footer">
                                            <button
                                                class="btn btn-primary prevBtn btn-lg pull-left btn_pre mr_20"
                                                type="button"
                                            >
                                                previous
                                            </button>
                                            <button
                                                class="btn btn_orange bg_primary_orange text_white des_add_cart nextBtn btn-lg pull-right btn_next"
                                                type="button"
                                            >
                                                Next
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </section>
        </div>
    </div>
</template>
<script>
export default {
    name: "BusinessCreditApp",
    mounted() {
        /* eslint-disable */
        $(document).ready(function () {
            var navListItems = $("div.setup-panel div a");
            var mainparent = $("div.setup-panel div"),
                allWells = $(".setup-content"),
                allNextBtn = $(".nextBtn"),
                allPrevBtn = $(".prevBtn");

            allWells.hide();

            navListItems.click(function (e) {
                e.preventDefault();
                var $target = $($(this).attr("href")),
                    $item = $(this);

                if (!$item.hasClass("disabled")) {
                    navListItems
                        .removeClass("btn-primary")
                        .addClass("btn-default");
                    $item.addClass("btn-primary");
                    $item.parent().prev().children("a").addClass("btn_submit");
                    $item.removeClass("btn_submit");
                    $item.parent().next().removeClass("select-active");
                    $item.parent().addClass("select-active");
                    allWells.hide();
                    $target.show();
                    $target.find("input:eq(0)").focus();
                }
            });

            allPrevBtn.click(function () {
                var curStep = $(this).closest(".setup-content"),
                    curStepBtn = curStep.attr("id"),
                    prevStepWizard = $(
                        'div.setup-panel div a[href="#' + curStepBtn + '"]'
                    )
                        .parent()
                        .prev()
                        .children("a");
                prevStepWizard.removeAttr("disabled").trigger("click");
            });

            allNextBtn.click(function () {
                var curStep = $(this).closest(".setup-content"),
                    curStepBtn = curStep.attr("id"),
                    nextStepWizard = $(
                        'div.setup-panel div a[href="#' + curStepBtn + '"]'
                    )
                        .parent()
                        .next()
                        .children("a"),
                    curInputs = curStep.find(
                        "input[type='text'],input[type='url']"
                    ),
                    isValid = true;

                $(".form-group").removeClass("has-error");
                for (var i = 0; i < curInputs.length; i++) {
                    if (!curInputs[i].validity.valid) {
                        isValid = false;
                        $(curInputs[i])
                            .closest(".form-group")
                            .addClass("has-error");
                    }
                }
                nextStepWizard.removeAttr("disabled").trigger("click");
            });
            $("div.setup-panel div a.btn-primary").trigger("click");
        });
        /* eslint-enable */
    }
};
</script>

<style></style>
